// import React, { ReactNode } from "react";
// import { Card, Typography, Box, useTheme } from "@mui/material";
// import { styled } from "@mui/material/styles";

// interface DashboardCardProps {
//   title: string;
//   value: string | number;
//   icon: ReactNode;
//   trendValue?: string | number;
// }

// const DashboardCard: React.FC<DashboardCardProps> = ({
//   title,
//   value,
//   icon,
//   trendValue,
// }) => {
//   const theme = useTheme();

//   const StyledCard = styled(Card)(({ theme }) => ({
//     backgroundColor:
//       theme.palette.mode === "dark"
//         ? theme.palette.background.paper
//         : "#ffffff",
//     borderRadius: "8px",
//     border: `1px solid ${theme.palette.divider}`, // ✅ grey border
//     boxShadow:
//       theme.palette.mode === "dark"
//         ? "0 2px 8px rgba(0,0,0,0.5)"
//         : "0 2px 8px rgba(0,0,0,0.1)",
//     padding: "15px",
//     height: "130px",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-between",
//   }));

//   return (
//     <StyledCard>
//       {/* Top Row: Text Left + Icon Right */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 1,
//         }}
//       >
//         <Typography
//           variant="subtitle2"
//           sx={{ fontWeight: 600, paddingLeft: "4px" }}
//         >
//           {title}
//         </Typography>

//         <Box
//           sx={{
//             width: 40,
//             height: 40,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backgroundColor: theme.palette.action.hover,
//             borderRadius: "8px",
//           }}
//         >
//           {icon}
//         </Box>
//       </Box>

//       {/* Value and Trend */}
//       <Box sx={{ paddingLeft: "4px" }}>
//         <Typography variant="h5" sx={{ fontWeight: 700 }}>
//           {value}
//         </Typography>

//         {trendValue && (
//           <Typography variant="caption" sx={{ color: "text.secondary" }}>
//             {trendValue}
//           </Typography>
//         )}
//       </Box>
//     </StyledCard>
//   );
// };

// export default DashboardCard;

import React, { ReactNode } from "react";
import { Card, Typography, Box, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

// Move styled component outside to prevent re-creation on every render
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.background.paper : "#ffffff",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 2px 8px rgba(0,0,0,0.5)"
      : "0 2px 8px rgba(0,0,0,0.1)",
  padding: "15px",
  height: "130px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

interface DashboardCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  trendValue?: string | number;
  loading?: boolean;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  icon,
  trendValue,
}) => {
  const theme = useTheme();

  return (
    <StyledCard>
      {/* Rest of your component remains the same */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, paddingLeft: "4px" }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.palette.action.hover,
            borderRadius: "8px",
          }}
        >
          {icon}
        </Box>
      </Box>

      {/* Value and Trend */}
      <Box sx={{ paddingLeft: "4px" }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {value}
        </Typography>

        {trendValue && (
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {trendValue}
          </Typography>
        )}
      </Box>
    </StyledCard>
  );
};

export default DashboardCard;
